__turbopack_context__.v({
  "disabled": "AudurLink-module-scss-module__sNCeIa__disabled",
  "linkContainer": "AudurLink-module-scss-module__sNCeIa__linkContainer",
  "selected": "AudurLink-module-scss-module__sNCeIa__selected",
  "underline": "AudurLink-module-scss-module__sNCeIa__underline",
});
